import React, { useEffect, useState } from "react";
import Head from "next/head";
import { styled } from "@mui/material/styles";
import funnel from "../styles/Funnel.module.css";
import { NumericFormat } from "react-number-format";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CardContent from "@mui/material/CardContent";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import MuiToggleButton from "@mui/material/ToggleButton";
import Link from "next/link";
import Footer from "../component/footer";
import CallToAction from "../component/callToAction";

const ToggleButton = styled(MuiToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "white",
    backgroundColor: "var(--primary-color)",
  },
});

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
});

const SelectButton = styled(Link)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "100%",
  height: "45px",
  fontSize: "16px",
  backgroundColor: "var(--primary-color)",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  marginTop: "15px",
  "&:hover": {
    border: "1px solid var(--dark-color)",
    backgroundColor: "var(--dark-color)",
  },
}));

const SearchButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "180px",
  height: "40px",
  fontSize: "15px",
  backgroundColor: "var(--primary-color)",
  borderRadius: "8px",
  "&:hover": {
    border: "1px solid var(--dark-color)",
    backgroundColor: "var(--dark-color)",
  },
  [theme.breakpoints.down("sm")]: {
    width: "150px",
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

let CustomSelect = styled(Select)(() => ({
  "&.MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
}));

export default function ReapaymentCalculator() {
  const [formData, setFormData] = React.useState({
    amount: "",
    rate: "",
    term: "",
    frequency: null,
  });

  const [error, setError] = React.useState({
    amount: false,
    rate: false,
    term: false,
    frequency: false,
  });

  const [repayment, setRepayment] = React.useState("");
  const [show, setShow] = React.useState(false);

  const handleChangeAmount = (event) => {
    setFormData({
      ...formData,
      amount: event.target.value,
    });
    setError({
      ...error,
      amount: false,
    });
  };

  let errorAmount;
  let helperTextAmount;
  if (error.amount == true) {
    errorAmount = "error";
    helperTextAmount = "Loan amount value cannot be empty!";
  } else {
    errorAmount = "";
    helperTextAmount = "";
  }

  const handleChangeRate = (event) => {
    setFormData({
      ...formData,
      rate: event.target.value,
    });
    setError({
      ...error,
      rate: false,
    });
  };

  let errorRate;
  let helperTextRate;
  if (error.rate == true) {
    errorRate = "error";
    helperTextRate = "Interest rate value cannot be empty!";
  } else {
    errorRate = "";
    helperTextRate = "";
  }

  const handleChangeTerm = (event) => {
    setFormData({
      ...formData,
      term: event.target.value,
    });
    setError({
      ...error,
      term: false,
    });
  };

  let errorTerm;
  let helperTextTerm;
  if (error.term == true) {
    errorTerm = "error";
    helperTextTerm = "Loan term value cannot be empty!";
  } else {
    errorTerm = "";
    helperTextTerm = "";
  }

  const handleChangeFrequency = (event) => {
    setFormData({ ...formData, frequency: event.target.value });
    setError({
      ...error,
      frequency: false,
    });
    setShow(false);
  };

  let helperTextFrequency;
  if (error.frequency == true) {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "red",
        },
        "&:hover fieldset": {
          borderColor: "red",
        },
        "&.Mui-focused fieldset": {
          borderColor: "red",
        },
      },
    }));
    helperTextFrequency = "Please select a option!";
  } else {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#cacaca",
        },
        "&:hover fieldset": {
          borderColor: "var(--primary-color)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "var(--primary-color)",
        },
      },
    }));
    helperTextFrequency = "";
  }

  const calculateButton = () => {
    if (formData.amount === "" || formData.amount.length <= 0) {
      setError({
        ...error,
        amount: true,
      });
    } else if (formData.rate === "" || formData.rate.length <= 0) {
      setError({
        ...error,
        rate: true,
      });
    } else if (formData.term === "" || formData.term.length <= 0) {
      setError({
        ...error,
        term: true,
      });
    } else if (formData.frequency === null) {
      setError({
        ...error,
        frequency: true,
      });
    } else if (
      error.amount == false &&
      error.rate == false &&
      error.term == false &&
      error.frequency == false
    ) {
      setError({
        ...error,
        amount: false,
        rate: false,
        term: false,
        frequency: false,
      });
      let amount = formData.amount.replaceAll(",", "");
      amount = parseInt(amount);
      let rate = parseFloat(formData.rate) / 100 / 12;
      let term = parseInt(formData.term) * 12;
      let cal;
      cal = amount * ((rate * (1 + rate) ** term) / (1 - (1 + rate) ** term));
      if (formData.frequency == "Weekly") {
        cal = (cal * 12) / 52;
      } else if (formData.frequency == "Fortnightly") {
        cal = (cal * 12) / 26;
      }
      let rep = Math.abs(Math.floor(cal));
      rep = rep.toLocaleString();
      setRepayment(rep);
      setShow(true);
    }
  };

  return (
    <>
      <Head>
        <title>Repayment calculator</title>
        <link
          rel="canonical"
          href="https://abodefinder.com.au/repayment_calculator/"
        ></link>
        <meta name="description" content="description" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"/>
      </Head>
      <Container sx={{ flexGrow: 12, mt: 3, mb: 10 }}>
        <Container sx={{ textAlign: "center" }}>
          <Typography
            variant="h1"
            sx={{ fontSize: "25px", fontWeight: "600", mt: 8, mb: 2 }}
          >
            Loan Repayment Calculator - Calculate Your Mortgage Repayments
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontSize: "22px", fontWeight: "600", mb: 3 }}
          >
            Calculate Your Home Loan Repayments with AbodeFinder's Repayment
            Calculator
          </Typography>
          <Typography variant="subtitle2" sx={{ fontSize: "18px" }}>
            Are you looking to take out a home loan but unsure of how much you
            can afford to repay? Our loan repayment calculator can help you get
            an estimate of what your repayments will be based on your loan
            amount, interest rate, and loan term.
          </Typography>
          <Typography variant="subtitle2" sx={{ fontSize: "18px" }}>
            Using our simple and user-friendly repayment calculator, you can
            adjust the loan amount, interest rate, and loan term to see how it
            affects your weekly, fortnightly, or monthly repayments. You can
            also compare the repayment amount for different loan terms to find
            the option that best suits your budget.
          </Typography>
          <Typography variant="subtitle2" sx={{ fontSize: "18px" }}>
            With AbodeFinder's repayment calculator, you can make informed
            decisions about your home loan and plan your finances accordingly.
            Our tool offers you the peace of mind that comes with knowing
            exactly what you can expect to pay each month, so you can
            confidently pursue your dream home.
          </Typography>
          <Typography variant="subtitle2" sx={{ fontSize: "18px" }}>
            Try our loan repayment calculator now and take the first step
            towards your homeownership journey with AbodeFinder.
          </Typography>
        </Container>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} spacing={2} columns={{ xs: 12 }}>
            <Item
              variant="outlined"
              sx={(theme) => ({
                p: 3,
                pt: 3,
                mt: 2,
                mb: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-left",
                borderRadius: "4px",
                [theme.breakpoints.down("sm")]: { p: 4 },
              })}
            >
              <Box
                sx={(theme) => ({
                  width: "100%",
                  mt: 3,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  [theme.breakpoints.down("sm")]: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  },
                })}
              >
                <div className={funnel.FunnelFieldCal}>
                  <h4 className={funnel.h4TextFunnel}>Loan amount</h4>
                  <FormControl fullWidth>
                    <NumericFormat
                      error={errorAmount}
                      helperText={helperTextAmount}
                      value={formData.amount}
                      name="loan-amount"
                      placeholder="450,000"
                      onChange={handleChangeAmount}
                      id="outlined-adornment-amount"
                      thousandSeparator=","
                      customInput={CssTextField}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </div>
                <div className={funnel.FunnelFieldCal}>
                  <h4 className={funnel.h4TextFunnel}>Interest rate</h4>
                  <FormControl fullWidth>
                    <NumericFormat
                      error={errorRate}
                      helperText={helperTextRate}
                      value={formData.rate}
                      name="Interest-rate"
                      placeholder="2.09"
                      onChange={handleChangeRate}
                      id="outlined-adornment-amount"
                      customInput={CssTextField}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </div>
              </Box>
              <Box
                sx={(theme) => ({
                  width: "100%",
                  mt: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  [theme.breakpoints.down("sm")]: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  },
                })}
              >
                <div className={funnel.FunnelFieldCal}>
                  <h4 className={funnel.h4TextFunnel}>Loan term</h4>
                  <FormControl fullWidth>
                    <NumericFormat
                      error={errorTerm}
                      helperText={helperTextTerm}
                      value={formData.term}
                      name="Loan-term"
                      placeholder="30"
                      onChange={handleChangeTerm}
                      id="outlined-adornment-amount"
                      customInput={CssTextField}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">years</InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </div>
                <div className={funnel.FunnelFieldCal}>
                  <h4 className={funnel.h4TextFunnel}>Repayment frequency</h4>
                  <FormControl fullWidth style={{ textAlign: "left" }}>
                    <CustomSelect
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={formData.frequency}
                      onChange={handleChangeFrequency}
                    >
                      <MenuItem value="Weekly">Weekly</MenuItem>
                      <MenuItem value="Fortnightly">Fortnightly</MenuItem>
                      <MenuItem value="Monthly">Monthly</MenuItem>
                    </CustomSelect>
                    <FormHelperText sx={{ color: "red" }}>
                      {helperTextFrequency}
                    </FormHelperText>
                  </FormControl>
                </div>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <SearchButton
                  variant="contained"
                  sx={(theme) => ({
                    mt: 1,
                    ml: 1,
                    width: "300px",
                    fontSize: "20px",
                    height: "50px",
                    [theme.breakpoints.down("sm")]: { mt: 4, ml: 0, mb: 3 },
                  })}
                  onClick={calculateButton}
                >
                  Calculate
                </SearchButton>
              </Box>
            </Item>
          </Grid>
        </Grid>
        {show && (
          <Grid container spacing={1}>
            <React.Fragment>
              <Grid item xs={12} md={12} columns={{ xs: 12 }}>
                <Paper
                  sx={{
                    p: 5,
                    mt: 5,
                    borderColor: "var(--primary-color)",
                    textAlign: "center",
                  }}
                  variant="outlined"
                >
                  <Typography variant="h4" gutterBottom>
                    Estimated repayment
                  </Typography>
                  <Typography
                    variant="h2"
                    sx={{ fontWeight: "600" }}
                    gutterBottom
                  >
                    $ {repayment}{" "}
                    <span style={{ fontSize: "22px", fontWeight: "500" }}>
                      / {formData.frequency}
                    </span>
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom>
                    Based on an interested rate of {formData.rate}% over{" "}
                    {formData.term} years
                  </Typography>
                </Paper>
              </Grid>
            </React.Fragment>
          </Grid>
        )}
        <CallToAction />
        <Item
          variant="outlined"
          sx={(theme) => ({
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "center",
            p: 2,
            mb: 5,
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
              width: "100%",
            },
          })}
        >
          <Item
            variant="outlined"
            sx={(theme) => ({
              width: "48%",
              height: "310px",
              mr: 2,
              mt: 1,
              mb: 1,
              [theme.breakpoints.down("md")]: { width: "100%", height: "auto" },
            })}
          >
            <CardContent
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar
                sx={{
                  width: 75,
                  height: 75,
                  backgroundColor: "var(--primary-color)",
                }}
              >
                <WhereToVoteIcon sx={{ fontSize: "50px" }} />
              </Avatar>
              <Typography
                variant="subtitle1"
                sx={{ textAlign: "center", mt: 3 }}
              >
                Find the perfect suburb for your next property investment with
                SuburbFinder. Get customised recommendations based on your
                budget, public transport needs, and school preferences.
              </Typography>
              <SelectButton href="/suburb-finder/">
                Find Your Perfect Suburb Now
              </SelectButton>
            </CardContent>
          </Item>
          <Item
            variant="outlined"
            sx={(theme) => ({
              width: "48%",
              height: "310px",
              mr: 2,
              mt: 1,
              mb: 1,
              [theme.breakpoints.down("md")]: { width: "100%", height: "auto" },
            })}
          >
            <CardContent
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar
                sx={{
                  width: 75,
                  height: 75,
                  backgroundColor: "var(--primary-color)",
                }}
              >
                <QueryStatsIcon sx={{ fontSize: "50px" }} />
              </Avatar>
              <Typography
                variant="subtitle1"
                sx={{ textAlign: "center", mt: 3 }}
              >
                Calculate your chances of buying the perfect property with our
                AI-powered Buying Chance Calculator. Get personalized insights
                based on your budget and selected suburbs.
              </Typography>
              <SelectButton href="/buying-chance/">
                Get Personalised Buying Insights Now
              </SelectButton>
            </CardContent>
          </Item>
        </Item>
      </Container>
      <Footer />
    </>
  );
}
